import { render, staticRenderFns } from "./TheoryCateManage.vue?vue&type=template&id=604ad0b8&scoped=true&"
import script from "./TheoryCateManage.vue?vue&type=script&lang=js&"
export * from "./TheoryCateManage.vue?vue&type=script&lang=js&"
import style0 from "./TheoryCateManage.vue?vue&type=style&index=0&id=604ad0b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ad0b8",
  null
  
)

export default component.exports